module.exports = __webpack_public_path__ + "img/transaksi-dijamin-aman.32545dc6.svg";